import {Columns} from 'compob2b-table';
import {translations} from '../../../environments/translations.ru';


export const DAM_ITEM_FORM: Columns[] = [
  {
    key: 'header',
    title: translations.header,
    placeholder: translations.header,
    searchEnabled: true,
    formly: true,
    grid: true,
    type: 'input',
    required: true,
  },
  {
    key: 'parentId',
    title: translations.parent,
    placeholder: translations.parent,
    searchEnabled: true,
    formly: true,
    type: 'dam-catalog-picker',
    templateOptions: {
      label: translations.parent,
      type: 'array',
      valueProp: 'id',
      labelProp: 'header',
      chooseOnlyLastLevel: false,
    },
    width: '100%',
    grid: false
  },

  {
    key: 'pos',
    title: translations.position,
    placeholder: translations.position,
    searchEnabled: true,
    formly: true,
    grid: false,
    type: 'input',
    required: false,
    defaultValue: 0,
    templateOptions: {
      label: translations.position,
      type: 'number',
      step: 1,
      required: true,
      min: 0,
      max: 1000000000,
    },
  },
  {
    key: 'enabled',
    title: translations.enabled,
    placeholder: translations.enabled,
    searchEnabled: false,
    formly: true,
    grid: false,
    defaultValue: true,
    type: 'checkbox',
    required: true
  },
  {
    key: 'action',
    title: translations.action,
    placeholder: translations.action,
    searchEnabled: false,
    grid: true,
    formly: false,
    type: 'input',
    required: true
  },
  {
    key: 'roles',
    title: translations.roles,
    placeholder: translations.roles,
    formly: true,
    type: 'multicheckbox',
    grid: false,
    templateOptions: {
      label: translations.roles,
      placeholder: translations.roles,
      required: true,
      type: 'array',
      valueProp: 'id',
      labelProp: 'header',
      description: 'Роли может изменять только супер администратор',
    },
  },
];
